import { DataSource } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { map } from 'rxjs/operators';
import { Observable, of as observableOf, merge } from 'rxjs';

// TODO: Replace this with your own data model type
export interface TableProrrogasItem {
  fecha_inicio: string;
  fecha_fin: string;
}

// TODO: replace this with real data from your application
const EXAMPLE_DATA: TableProrrogasItem[] = [
  {fecha_inicio: '23-04-2020', fecha_fin: '23-04-2020'},
  {fecha_inicio: '23-04-2020', fecha_fin: '23-04-2020'},
];

/**
 * Data source for the TableProrrogas view. This class should
 * encapsulate all logic for fetching and manipulating the displayed data
 * (including sorting, pagination, and filtering).
 */
export class TableProrrogasDataSource extends DataSource<TableProrrogasItem> {
  data: TableProrrogasItem[] = EXAMPLE_DATA;
  paginator: MatPaginator;
  sort: MatSort;

  constructor() {
    super();
  }

  /**
   * Connect this data source to the table. The table will only update when
   * the returned stream emits new items.
   * @returns A stream of the items to be rendered.
   */
  connect(): Observable<TableProrrogasItem[]> {
    // Combine everything that affects the rendered data into one update
    // stream for the data-table to consume.
    const dataMutations = [
      observableOf(this.data),
      this.paginator.page,
      this.sort.sortChange
    ];

    return merge(...dataMutations).pipe(map(() => {
      return this.getPagedData(this.getSortedData([...this.data]));
    }));
  }

  /**
   *  Called when the table is being destroyed. Use this function, to clean up
   * any open connections or free any held resources that were set up during connect.
   */
  disconnect() {}

  /**
   * Paginate the data (client-sfecha_inicioe). If you're using server-sfecha_inicioe pagination,
   * this would be replaced by requesting the appropriate data from the server.
   */
  private getPagedData(data: TableProrrogasItem[]) {
    const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
    return data.splice(startIndex, this.paginator.pageSize);
  }

  /**
   * Sort the data (client-sfecha_inicioe). If you're using server-sfecha_inicioe sorting,
   * this would be replaced by requesting the appropriate data from the server.
   */
  private getSortedData(data: TableProrrogasItem[]) {
    if (!this.sort.active || this.sort.direction === '') {
      return data;
    }

    return data.sort((a, b) => {
      const isAsc = this.sort.direction === 'asc';
      switch (this.sort.active) {
        case 'fecha_inicio': return compare(a.fecha_inicio, b.fecha_inicio, isAsc);
        case 'fecha_fin': return compare(+a.fecha_fin, +b.fecha_fin, isAsc);
        default: return 0;
      }
    });
  }
}

/** Simple sort comparator for example fecha_inicio/fecha_fin columns (for client-sfecha_inicioe sorting). */
function compare(a: string | number, b: string | number, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
